import { render, staticRenderFns } from "./404.vue?vue&type=template&id=ba98b514&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=ba98b514&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports